define("analytics-resources/utils/charts/tooltip-utils", ["exports", "analytics-resources/types/chart-types", "moment-timezone"], function (_exports, _chartTypes, _momentTimezone) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.formatDate = formatDate;
  _exports.formatTooltipForMultiSeries = formatTooltipForMultiSeries;
  _exports.formatWeeklyData = formatWeeklyData;
  0; //eaimeta@70e063a35619d71f0,"analytics-resources/types/chart-types",0,"moment-timezone"eaimeta@70e063a35619d71f
  function formatDate(valueUnits, timeZone, locale) {
    let precision = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let name = arguments.length > 4 ? arguments[4] : undefined;
    return function () {
      const value = Number(this.y.toFixed(precision)).toLocaleString();
      const formattedValue = `${value}${valueUnits || _chartTypes.ChartUnits.None}`;
      const date = locale.formatDate((0, _momentTimezone.default)(this.x).tz(timeZone), locale.DATE_LENGTH.MEDIUM);
      return `<div><div class="u--text--sm u--p__b__xs"><strong>${date}</strong></div>
      <div class="u--text--lg">${formattedValue}</div>
      <div class="u--text--sm u--text--light">${name || this.series.name}</div>`;
    };
  }
  function formatTooltipForMultiSeries(valueUnits, timeZone, locale) {
    return function () {
      const date = locale.formatDate((0, _momentTimezone.default)(this.x).tz(timeZone), locale.DATE_LENGTH.MEDIUM);
      const dateStr = `<div><div class="u--text--sm u--p__b__xs"><strong>${date}</strong></div>`;
      const formattedValues = this.points ? this.points.map(point => {
        const value = Number(point.y.toFixed(0)).toLocaleString();
        const formattedValue = `${value}${valueUnits || _chartTypes.ChartUnits.None}`;
        return `<div class="u--text--lg">${formattedValue}</div>
      <div class="u--text--sm u--text--light">${point.series.name}</div>`;
      }) : [];
      return [dateStr].concat(formattedValues);
    };
  }
  function formatWeeklyData(valueUnits, valueDisplayFormat, timeZone, locale) {
    return function () {
      const percentString = valueUnits ? valueUnits : _chartTypes.ChartUnits.None;
      const abbreviatedFormat = valueDisplayFormat === _chartTypes.DisplayFormat.Average ? 'Avg.' : 'Total';
      const date = locale.formatDate((0, _momentTimezone.default)(this.x).tz(timeZone), locale.DATE_LENGTH.MEDIUM);
      const futureDate = locale.formatDate((0, _momentTimezone.default)(this.x).tz(timeZone).add(6, 'days'), locale.DATE_LENGTH.MEDIUM);
      return `<div><div class="u--text--sm u--p__b__xs"><strong>${date} - ${futureDate}</strong></div>
      <div class="u--text--lg">${Number(this.y.toFixed(0)).toLocaleString()}${percentString} ${abbreviatedFormat}</div>
      <div class="u--text--sm u--text--light">${this.series.name}</div>`;
    };
  }
});